import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";

const ResponsiblePage = () => {
    usePageTitle('Responsible Gaming');
    return (
        <>
            <section className="page-header">
                <h1>🛡️ RESPONSIBLE GAMING 🛡️</h1>
                {/* Inline style for the green text */}
                <p style={{ color: '#66ff66', fontSize: '1.2rem' }}>
                    Your wellbeing is our priority
                </p>
                <Link to="/" className="back-button">
                    ← BACK TO HOME
                </Link>
            </section>

            {/* Main Content Container */}
            <div className="content-container">
                <div className="warning-box">
                    <h2>⚠️ IMPORTANT MESSAGE</h2>
                    <p>
                        While noravo.site involves NO REAL MONEY, we recognize that gambling addiction is a serious issue affecting millions worldwide. If you or someone you know has a gambling problem, please seek help immediately.
                    </p>
                </div>

                <div className="responsible-box">

                    <h2>🎯 OUR COMMITMENT</h2>
                    <p>
                        noravo.site was created specifically to provide a safe alternative to real-money gambling. Our entire purpose is to prevent the financial and emotional harm caused by gambling addiction.
                    </p>
                    <p>
                        This platform exists to demonstrate that entertainment doesn't require risking your hard-earned money. We believe that by offering free, engaging alternatives, we can help reduce gambling-related harm.
                    </p>

                    <h2>🚨 WARNING SIGNS OF GAMBLING ADDICTION</h2>
                    <p>Gambling becomes a problem when it causes harm to you or others. Watch for these signs:</p>
                    <ul>
                        <li>Spending more money or time gambling than you can afford</li>
                        <li>Having trouble controlling or stopping gambling behavior</li>
                        <li>Lying to family or friends about gambling</li>
                        <li>Borrowing money or selling possessions to gamble</li>
                        <li>Feeling restless or irritable when trying to stop</li>
                        <li>Gambling to escape problems or negative feelings</li>
                        <li>Chasing losses by gambling more to win back money</li>
                        <li>Neglecting work, family, or personal responsibilities</li>
                        <li>Relationship problems caused by gambling</li>
                        <li>Financial difficulties due to gambling losses</li>
                    </ul>

                    <h2>💡 HEALTHY ENTERTAINMENT HABITS</h2>
                    <p>Whether using our platform or engaging in any entertainment, practice these healthy habits:</p>
                    <ul>
                        <li><strong>Set Time Limits:</strong> Decide in advance how long you'll play</li>
                        <li><strong>Never Chase Losses:</strong> Accept that losses happen and move on</li>
                        <li><strong>Balance Activities:</strong> Maintain diverse hobbies and interests</li>
                        <li><strong>Stay Social:</strong> Engage with friends and family regularly</li>
                        <li><strong>Be Honest:</strong> Talk openly about your entertainment habits</li>
                        <li><strong>Recognize Triggers:</strong> Understand what prompts excessive behavior</li>
                        <li><strong>Take Breaks:</strong> Step away regularly to maintain perspective</li>
                    </ul>

                    <h2>🎓 EDUCATION IS PREVENTION</h2>
                    <p>
                        Understanding gambling mechanics and odds is crucial. Real social casino games and gambling sites are designed to ensure the house always wins in the long run. The odds are mathematically stacked against players.
                    </p>

                    {/* Info Box */}
                    <div className="info-box">
                        <h3>Key Facts About Gambling:</h3>
                        <p>• The house edge means you will lose money over time</p>
                        <p>• "Hot streaks" and "lucky systems" are illusions</p>
                        <p>• Casinos profit from people's losses</p>
                        <p>• No strategy can overcome mathematical disadvantages</p>
                        <p>• Gambling should never be considered income</p>
                    </div>

                    <h2>👨‍👩‍👧‍👦 FOR FAMILIES AND FRIENDS</h2>
                    <p>If someone you care about has a gambling problem:</p>
                    <ul>
                        <li>Express concern without judgment</li>
                        <li>Encourage them to seek professional help</li>
                        <li>Avoid enabling behavior (lending money, covering debts)</li>
                        <li>Set boundaries to protect yourself financially</li>
                        <li>Offer emotional support during recovery</li>
                        <li>Educate yourself about gambling addiction</li>
                    </ul>
                </div>

                {/* Help Resources Header */}
                <h2
                    style={{
                        textAlign: 'center',
                        fontSize: '2.5rem',
                        margin: '3rem 0',
                        textShadow: '0 0 15px #00ff00'
                    }}
                >
                    📞 HELP RESOURCES
                </h2>

                <div className="resource-grid">
                    <div className="resource-card">
                        <div className="resource-icon">🆘</div>
                        <h3>National Council on Problem Gambling</h3>
                        <p>24/7 confidential helpline for gambling addiction support</p>
                        <p style={{ fontWeight: 'bold', color: '#00ff00' }}>1-800-522-4700</p>
                    </div>

                    <div className="resource-card">
                        <div className="resource-icon">💬</div>
                        <h3>Gamblers Anonymous</h3>
                        <p>Free peer support program with meetings worldwide</p>
                        <p style={{ fontWeight: 'bold', color: '#00ff00' }}>www.gamblersanonymous.org</p>
                    </div>

                    <div className="resource-card">
                        <div className="resource-icon">🌐</div>
                        <h3>SAMHSA National Helpline</h3>
                        <p>Mental health and substance abuse treatment referral</p>
                        <p style={{ fontWeight: 'bold', color: '#00ff00' }}>1-800-662-4357</p>
                    </div>

                    <div className="resource-card">
                        <div className="resource-icon">🏥</div>
                        <h3>Crisis Text Line</h3>
                        <p>Free 24/7 support via text message</p>
                        <p style={{ fontWeight: 'bold', color: '#00ff00' }}>Text HOME to 741741</p>
                    </div>

                    <div className="resource-card">
                        <div className="resource-icon">💰</div>
                        <h3>Financial Counseling</h3>
                        <p>Nonprofit credit counseling for debt management</p>
                        <p style={{ fontWeight: 'bold', color: '#00ff00' }}>NFCC: 1-800-388-2227</p>
                    </div>

                    <div className="resource-card">
                        <div className="resource-icon">👥</div>
                        <h3>Gam-Anon</h3>
                        <p>Support for family members affected by gambling</p>
                        <p style={{ fontWeight: 'bold', color: '#00ff00' }}>www.gam-anon.org</p>
                    </div>
                </div>

                <div className="responsible-box">
                    <h2>🤝 OUR PROMISE</h2>
                    <p>
                        noravo.site will NEVER ask for money, NEVER promote real gambling, and will ALWAYS remain a free, safe entertainment platform. Our mission is harm prevention, not profit.
                    </p>
                    <p>
                        If you find yourself spending excessive time on gambling platforms, it may be a sign to reevaluate your entertainment choices. Even free games should be enjoyed in moderation.
                    </p>
                    <p>
                        Remember: Entertainment should add joy to your life, not create stress, financial problems, or relationship issues. Your wellbeing matters more than any game.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default ResponsiblePage;